import ButtonComponent from './ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core';
const ButtonIconComponent = props=>{

    return (
        <ButtonComponent style={props.style} onClick={props.onClick} className={" "+props.className}>
            <FontAwesomeIcon icon={props.icon} />
            {props.children}
        </ButtonComponent>
    )

}
export default ButtonIconComponent